import type { PostSpaceSummary } from "@circle-react/types/AiSummary/SpaceSummary";
import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";
import { AiSummary } from "@/react/components/shared/AiSummary";

import { getAnimationDelay } from "./animations";

interface SpaceTopicsListProps {
  topics: NonNullable<PostSpaceSummary["topics"]>;
}

export const TopicsListV4 = ({ topics }: SpaceTopicsListProps) => (
  <>
    <div
      className="animate-fade-in-slow mb-2 opacity-0"
      style={{
        animationDelay: getAnimationDelay(3),
        animationFillMode: "forwards",
      }}
    >
      <Typography variant="label-sm">
        {t("ai_spaces_summaries.takeaways")}
      </Typography>
    </div>
    <ul className="space-y-2">
      {topics.map((topic, index) => (
        <li
          key={topic.topic_name}
          className="animate-fade-in-slow flex items-baseline opacity-0"
          style={{
            animationDelay: getAnimationDelay(index + 4),
            animationFillMode: "forwards",
          }}
        >
          <div className="flex-1">
            <div className="pt-1">
              <strong>
                <Typography variant="label-sm" component="span">
                  {topic.topic_name}
                </Typography>
              </strong>
            </div>
            <AiSummary.TextWithUserLinks
              text={topic.summary}
              relevantPosts={topic.relevant_posts}
            />
            {topic.summary_subcategories_by_author &&
              topic.summary_subcategories_by_author.length > 0 && (
                <ul className="space-y-1">
                  {topic.summary_subcategories_by_author.map(
                    (subcategory: string) => (
                      <li
                        key={`${topic.topic_name}-${subcategory}`}
                        className="animate-fade-in-slow flex items-baseline pl-2 opacity-0"
                        style={{
                          animationDelay: getAnimationDelay(index + 4),
                          animationFillMode: "forwards",
                        }}
                      >
                        <span className="mr-2">
                          <Typography variant="body-sm" component="span">
                            {t("ai_spaces_summaries.bullet")}
                          </Typography>
                        </span>
                        <AiSummary.TextWithUserLinks text={subcategory} />
                      </li>
                    ),
                  )}
                </ul>
              )}
          </div>
        </li>
      ))}
    </ul>
  </>
);
